import * as React from "react";

import { Button, Icon, Tabs, Tooltip } from "antd";
import styles from './Banners.module.less'
import { IActiveFolders } from "../../store/banner/template/files/types";
import { IFileWithData } from "../../store/files/types";
import FileData, { IFileDataProps } from "../FileSystem/FileData";
import { IdObjectsWithId } from "../../utils";
import { IFileData } from "../../store/files/filedata/types";
import { marginLeft } from "html2canvas/dist/types/css/property-descriptors/margin";

const { TabPane } = Tabs;

interface IOwnProps {
    size?: number;
    activeFolders: IActiveFolders
    filesData: IdObjectsWithId<IFileData>
    isSavingFileData: boolean;
}

export type IOnFileWithDataChangeParams = { key: string, fileWithData: IFileWithData }

interface ICallbackProps {
    onFileChange?: (params: IOnFileWithDataChangeParams) => void;
    onReloadFiles?: () => void;
    renderPreview?: () => void;
    onSaveFileWithData?: (fileWithData: IFileWithData) => void;
}

export type IFileTemplatesProps = IOwnProps & ICallbackProps

interface IState {
    activeFolderKey: string
    activeFileKey: {
        [folder: string]: string
    }
}

class HtmlTemplate extends React.PureComponent<IFileTemplatesProps, IState> {
    state: IState = {
        activeFolderKey: "scss",
        activeFileKey: {
            "scss": "_base.scss",
            "html": "_content.html"
        }
    };

    onFolderTabChange = (activeKey: string) => {
        this.setState({ activeFolderKey: activeKey })
    }

    onFileTabChange = (activeKey: string) => {
        this.setState({
            activeFileKey: {
                ...this.state.activeFileKey,
                [this.state.activeFolderKey]: activeKey
            }
        })
    }

    onFileDataChange = (value: string) => {
        const activeFileWithData = this.activeFile()
        if (activeFileWithData && activeFileWithData.activeFileData) {
            let updated: IFileWithData = {
                ...activeFileWithData,
                activeFileData: {
                    ...activeFileWithData.activeFileData,
                    data: value
                }
            }
            if (this.props.onFileChange) {
                this.props.onFileChange({ key: updated.name, fileWithData: updated })
            }
        }
    }

    saveActiveFile = () => {
        if (this.props.onSaveFileWithData) {
            const file = this.activeFile()
            if (file) {
                this.props.onSaveFileWithData(file)
            }
        }
    };

    saveButtonText = () => {
        if (this.isActiveFileReadOnly()) {
            return "Can't update parent's file."
        }
        return "Save"
    }

    isSaveButtonDisabled = () => {
        return this.isActiveFileReadOnly() || !this.hasActiveFileChanged()
    }

    isActiveFileReadOnly = () => {
        const file = this.activeFile();
        if (file) {
            return file.readonly
        }
        return true
    };

    hasActiveFileChanged = () => {
        const file = this.activeFile();
        if (!file) {
            return
        }
        if (!file.fileDataId) {
            return
        }
        const fileData = this.props.filesData.byId[file.fileDataId]
        if (file && fileData && file.activeFileData) {
            return fileData.data !== file.activeFileData.data
        }
        return false
    }

    activeFile = (): IFileWithData | undefined => {
        let file: IFileWithData | undefined
        const activeFolder = this.state.activeFolderKey
        const activeFileKey = this.state.activeFileKey[this.state.activeFolderKey]
        if (this.props.activeFolders.scss && activeFolder === "scss") {
            file = this.props.activeFolders.scss[activeFileKey]
        } else if (this.props.activeFolders.html && activeFolder === "html") {
            file = this.props.activeFolders.html[activeFileKey]
        }
        return file
    }

    reLoadActiveFolders = () => {
        if (this.props.onReloadFiles) {
            this.props.onReloadFiles()
        }
    };

    render() {
        // console.log("VariablesSets render........")

        const isSaveButtonDisabled = this.isSaveButtonDisabled();
        let saveButton = <Button
            type={isSaveButtonDisabled ? "default" : "primary"}
            style={{ marginRight: 10 }}
            loading={this.props.isSavingFileData}
            disabled={isSaveButtonDisabled}
            onClick={this.saveActiveFile}
        >
            {this.saveButtonText()}
        </Button>
        let reloadButton = <Button onClick={this.reLoadActiveFolders}>Reload Files</Button>
        let previewButton = <Tooltip title="Rebuild Banner">
            <Icon style={{ marginLeft: "10px" }} type="redo" onClick={this.props.renderPreview} />
        </Tooltip>

        return (
            <div className={styles.templateTab}>
                <Tabs
                    animated={false}
                    activeKey={this.state.activeFolderKey}
                    defaultActiveKey={this.state.activeFolderKey}
                    size="small"
                    onChange={this.onFolderTabChange}
                    tabBarExtraContent={<span>{saveButton}{reloadButton}{previewButton}</span>}
                >
                    {this.props.activeFolders && Object.keys(this.props.activeFolders).map((name: string) => {
                        let folder = this.props.activeFolders[name]
                        const activeFileKey = this.state.activeFileKey[name]
                        return (
                            <TabPane tab={name} key={name} className={styles.templateTab}>
                                <Tabs
                                    animated={false}
                                    activeKey={activeFileKey}
                                    defaultActiveKey={activeFileKey}
                                    size="small"
                                    onChange={this.onFileTabChange}
                                >
                                    {folder && Object.keys(folder).map((filename: string) => {
                                        let fileWithData: IFileWithData | undefined
                                        let fileDataProps: IFileDataProps = {} as IFileDataProps
                                        if (folder) {
                                            fileWithData = folder[filename]
                                            if (!fileWithData) {
                                                return null;
                                            }
                                            if (!fileWithData.fileDataId) {
                                                return null;
                                            }
                                            let fileData = this.props.filesData.byId[fileWithData.fileDataId]

                                            if (fileWithData && fileWithData.activeFileData && fileData) {
                                                const name = fileWithData.name
                                                const nameParts = name.split('.')
                                                let fileType = 'html';
                                                if (nameParts.length > 1) {
                                                    fileType = nameParts[nameParts.length - 1]
                                                }

                                                fileDataProps = {
                                                    size: this.props.size,
                                                    activeKey: activeFileKey,
                                                    activeFileData: fileWithData.activeFileData,
                                                    originalFileData: fileData,
                                                    fileType: fileType,
                                                    onFileDataChange: this.onFileDataChange
                                                }
                                            }

                                            return (fileWithData && fileData &&
                                                <TabPane tab={filename} key={filename} className={styles.templateTab}>
                                                    <div>{fileWithData.path}</div>
                                                    <FileData {...fileDataProps} />
                                                </TabPane>
                                            )
                                        }
                                    })}
                                </Tabs>
                            </TabPane>
                        )
                    })}
                </Tabs>
            </div>
        )
    }
}

export default HtmlTemplate;

